export function questions(state = [], action) {
  switch (action.type) {
    case 'QUESTIONS_FETCH_DATA_SUCCESS':
      return action.questions;
    default:
      return state;
  }
}
export function information(state = [], action) {
  switch (action.type) {
    case 'INFORMATION_QUESTIONS_FETCH_DATA_SUCCESS':
      return action.questions;
    default:
      return state;
  }
}
export function mersalg(state = [], action) {
  switch (action.type) {
    case 'MERSALG_QUESTIONS_FETCH_DATA_SUCCESS':
      return action.questions;
    default:
      return state;
  }
}
export function answers(state = [], action) {
  switch (action.type) {
    case 'ANSWERS_FETCH_DATA_SUCCESS':
      return action.answers;
    default:
      return state;
  }
}
export function scripts(state = [], action) {
  switch (action.type) {
    case 'SCRIPTS_FETCH_DATA_SUCCESS':
      return action.scripts;
    default:
      return state;
  }
}
